import React from 'react';

const TestimonialPost = props => {
    const { img, name, title, description } = props.testimonial;

    return (
        <div className="testimonial">
            <figure className="testimonialShape">
                <img src={img} alt={name} className="testimonialImg" />
                <figcaption className="testimonialCaption">{name}</figcaption>
            </figure>
            <div className="testimonialText">
                <h3 className="mbSmall">{title}</h3>
                <p>{description}</p>
            </div>
        </div> // Testimonial
    );
};

export default TestimonialPost;